module.exports = __webpack_public_path__ + "img/131.8.171427c8.png";